// extracted by mini-css-extract-plugin
module.exports = {"noNotifications":"ea_eb","loading":"ea_ec"};